var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isOnboard)?_c('keep-alive',[_c('my-head')],1):_vm._e(),_c('section',{attrs:{"id":"section"}},[(!_vm.isOnboard)?_c('keep-alive',[_c('my-menu')],1):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }